import { useEffect, useState } from "react";
import api from "../../api/api";
import { IMAGE_URL } from "../../path";
import AdminLayout from "./Components/AdminLayout";
import '../../styles/Admin.css'

function AdminContactUs() {

    const [page, setPage] = useState<any>(null);

    const [coverImage, setCoverImage] = useState<File | null>(null);
    const [coverPreview, setCoverPreview] = useState("");

    const [headerBody, setHeaderBody] = useState("");

    const [contact, setContact] = useState<any>(null);

    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [fax, setFax] = useState("");
    const [officeName, setOfficeName] = useState("");
    const [officeLink, setOfficeLink] = useState("");

    const [saving, setSaving] = useState(false);

    useEffect(() => {

        loadPage();

    }, []);

    const getImageUrl = (path?: string) => {

        if (!path) {
            return "";
        }

        if (path.startsWith("http")) {
            return path;
        }

        return `${IMAGE_URL}${path}`;
    };

    const handleCoverImage = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {

        const file = e.target.files?.[0];

        if (!file) {
            return;
        }

        if (file.size > 2 * 1024 * 1024) {

            alert("Image must be 2MB or smaller.");

            return;
        }

        setCoverImage(file);
        setCoverPreview(URL.createObjectURL(file));

    };

    const handleSave = async () => {

        try {

            setSaving(true);

            if (coverImage) {

                const formData = new FormData();

                formData.append("image", coverImage);

                await api.post(
                    "/page-header/contact-us/cover-image",
                    formData
                );

            }

            await api.put(
                "/page-header/contact-us/header-body",
                {
                    header_body: headerBody,
                }
            );

            const contactData = {
                email,
                phone,
                fax,
                office_name: officeName,
                office_link: officeLink,
            };

            if (contact?.id) {

                await api.put(
                    `/contact-us/${contact.id}`,
                    contactData
                );

            } else {

                await api.post(
                    "/contact-us",
                    contactData
                );

            }

            await loadPage();

            setCoverImage(null);

            alert("Contact Us updated successfully.");

        } catch (error: any) {

            console.error(error);

            alert(
                error?.response?.data?.message ??
                "Failed to save changes."
            );

        } finally {

            setSaving(false);

        }

    };

    const loadPage = async () => {

        try {

            const pageResponse =
                await api.get("/page-header/contact-us");

            const contactResponse =
                await api.get("/contact-us");

            const pageData =
                pageResponse.data.page;

            setPage(pageData);

            setHeaderBody(
                pageData?.header_body ?? ""
            );

            if (pageData?.cover_image) {

                setCoverPreview(
                    getImageUrl(
                        pageData.cover_image
                    )
                );

            }

            const contactData =
                contactResponse.data;

            if (contactData?.id) {

                setContact(contactData);

                setEmail(contactData.email);
                setPhone(contactData.phone);
                setFax(contactData.fax);
                setOfficeName(contactData.office_name);
                setOfficeLink(contactData.office_link);

            }

        } catch (error) {

            console.error(error);

        }

    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Contact Us
                </h1>

                <button
                    className="action-btn"
                    onClick={handleSave}
                    disabled={saving}
                >
                    {saving ? "Saving..." : "Save Changes"}
                </button>

            </div>

            <div className="admin-card">

                <h2>
                    Cover Image
                </h2>

                {coverPreview && (

                    <img
                        src={coverPreview}
                        alt=""
                        className="image-preview"
                    />

                )}

                <p className="field-hint">
                    Maximum file size: 2MB
                </p>

                <input
                    type="file"
                    accept="image/*"
                    onChange={handleCoverImage}
                />

            </div>

            <div className="admin-card description">

                <label>
                    Header Body
                </label>

                <textarea
                    rows={8}
                    className="form-control"
                    value={headerBody}
                    onChange={(e) =>
                        setHeaderBody(
                            e.target.value
                        )
                    }
                />

            </div>

            <div className="admin-card">

                <h2>
                    Contact Details
                </h2>

                <div className="modal-form">

                    <label>
                        Email
                    </label>

                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />

                    <label>
                        Phone
                    </label>

                    <input
                        type="text"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                    />

                    <label>
                        Fax
                    </label>

                    <input
                        type="text"
                        value={fax}
                        onChange={(e) => setFax(e.target.value)}
                        required
                    />

                    <label>
                        Office Name
                    </label>

                    <input
                        type="text"
                        value={officeName}
                        onChange={(e) => setOfficeName(e.target.value)}
                        required
                    />

                    <label>
                        Office Link
                    </label>

                    <input
                        type="url"
                        value={officeLink}
                        onChange={(e) => setOfficeLink(e.target.value)}
                        required
                    />

                </div>

            </div>

        </AdminLayout>

    );

}

export default AdminContactUs;
